import React, { useState, useEffect } from "react";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import axios from "axios";
import Loader from "../../Components/Loader";
import DeleteIcon from "@mui/icons-material/Delete";
import "../../Styles/ViewExamination.css";

function CancelExams() {
    const [exams, setExams] = useState([]);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        const fetchExams = async () => {
            setLoading(true);
            try {
                const token = localStorage.getItem("authToken");
                const response = await axios.get("https://api.uniums.com/api/exam/view-exams-cancel", {
                    headers: { Authorization: `Bearer ${token}` },
                });

                setExams(response.data);
            } catch (error) {
                console.error("Error fetching exams:", error);
                toast.error("Failed to fetch exams.");
            } finally {
                setLoading(false);
            }
        };

        fetchExams();
    }, []);

    const handleDeleteExam = async (examId) => {
        try {
            const token = localStorage.getItem("authToken");
            await axios.delete(`https://api.uniums.com/api/exam/delete-exam/${examId}`, {
                headers: { Authorization: `Bearer ${token}` },
            });

            toast.success("Exam deleted successfully!");
            setExams((prevExams) => prevExams.filter((exam) => exam._id !== examId));
        } catch (error) {
            console.error("Error deleting exam:", error);
            toast.error("Failed to delete exam.");
        }
    };

    return (
        <div className="view-examination-container">
            <ToastContainer />
            {loading && <Loader />}
            <h1>Manage Examinations</h1>

            <div className="exam-cards">
                {exams.length === 0 && !loading ? (
                    <p className="no-data-message">No data found</p>
                ) : (
                    exams.map((exam) => (
                        <div className="exam-card" key={exam._id}>
                            <h2>Test Name: {exam.examName}</h2>
                            <p>
                                <strong>Date:</strong> {new Date(exam.examDate).toLocaleDateString()}
                            </p>
                            <p>
                                <strong>Time:</strong> {exam.examTime || "N/A"}
                            </p>
                            <p>
                                <strong>Class:</strong> {exam.className}
                            </p>
                            <p>
                                <strong>Subjects:</strong>
                            </p>
                            <ul>
                                {exam.subjects.map((subject) => (
                                    <li key={subject.subject}>
                                        {subject.subject} - {subject.questionType} ({subject.totalMarks} marks)
                                    </li>
                                ))}
                            </ul>
                            <p>
                                <strong>Details:</strong> {exam.examDetails || "No details available"}
                            </p>
                            <p className="remark_color">
                                <strong>Remark:</strong> {exam.remark}
                            </p>
                            <p className="download_btn_p">
                                {exam.documentDetails ? (
                                    <a href={exam.documentDetails} download>Download File</a>
                                ) : (
                                    "Document Not Available"
                                )}
                            </p>
                            <button
                                className="delete_button_exam"
                                onClick={() => handleDeleteExam(exam._id)}
                            >
                                <DeleteIcon /> Delete Exam
                            </button>
                        </div>
                    ))
                )}
            </div>
        </div>
    );
}

export default CancelExams;
